export default "__VITE_ASSET__D_VNR3Ln__"